import { useContext } from "react";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";

import { Card } from "react-bootstrap";
import useListAction from "@beeldit/core/actions/list/useListAction";
import useCreateAction from "@beeldit/core/actions/create/useCreateAction";
import useEditAction from "@beeldit/core/actions/edit/useEditAction";
import useRemoveAction from "@beeldit/core/actions/remove/useRemoveAction";
import { getTableConfig } from "@beeldit/core/helpers/tables";
import usePayAction from "../actions/pay/usePayAction";

function PaymentTablePage(props: {
  modelConfig: any,  
  templates?: [],
}) {
  const { modelConfig, templates } = props;
  const { user } = useContext(AuthContext);  

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(modelConfig, user);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(modelConfig, indexFunction);

  const { getFunction, actionTemplate: editActionTemplate } =
    useEditAction(modelConfig, indexFunction);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(modelConfig, indexFunction);

  const { preparePayFunction, actionTemplate: payActionTemplate } =
    usePayAction(modelConfig, indexFunction);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  let tableConfig = getTableConfig(modelConfig.tableConfig, {
    indexFunction: indexFunction,
    actionsFunctions: [
      {
        name: "create",
        function: initializeFunction,
      },
    ],
    rowFunctions: [
      {
        name: "pay",
        function: preparePayFunction,
      },      
    ],
  });
  setTableConfig(tableConfig);

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <span>{t(modelConfig.modelPluralName)}</span>
        <div>
          <BeelditTableHeaderActions
            actions={tableConfig.actions}
          ></BeelditTableHeaderActions>
        </div>
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {editActionTemplate}
        {removeActionTemplate}
        {payActionTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default PaymentTablePage;
